if (!process.env.VUE_APP_DEBUG || process.env.VUE_APP_DEBUG != 'true')
  if (window) {
    // eslint-disable-next-line
    window.console.log = function () { };
  }

// FIREBASE

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyD9gDllKjkvwHiGBvy9cuPU6GqtNJm7dYM",
  authDomain: "gimolott-23fd2.firebaseapp.com",
  databaseURL: "https://gimolott-23fd2.firebaseio.com",
  projectId: "gimolott-23fd2",
  storageBucket: "gimolott-23fd2.appspot.com",
  messagingSenderId: "244590919155",
  appId: "1:244590919155:web:c9b8da3a2bef7d7b426686",
  measurementId: "G-SDHHT4WPHQ"
};


// eslint-disable-next-line
const fbapp = firebase.initializeApp(firebaseConfig);

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.NONE)
firebase.auth().languageCode = 'vi';


import { Plugins } from '@capacitor/core';


import { createApp } from 'vue'
import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

// initialize HTTP support
import '@capacitor-community/http';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

import App from './App.vue'

import PrimeVue from 'primevue/config';

import 'primevue/resources/themes/saga-blue/theme.css';       //theme
import 'primevue/resources/primevue.min.css';                 //core css
import 'primeicons/primeicons.css';                           //icons

// store && plugins (after firebase initialized)
import moment from './plugins/moment.js';

// routes
import router from './router/index.js';

// CREATE IONIC APP


// app.config.errorHandler = function (err, vm, info) {
//   console.log("GLOBAL ERRROR HANDLER", err);
// }


// restore firebase user if any
const { Storage } = Plugins;
let userData = null;

Storage.get({ key: 'fbuser' }).then( async (userStore) => {
  const userJson = userStore.value;

  try {
    userData = JSON.parse(String(userJson));
    // eslint-disable-next-line
    // @ts-ignore
    if (userData && (userData.phoneNumber == "+84987654321" || userData.phoneNumber == "+84987654322")) userData = null;
  } catch(ex) {
    userData = null;
  }


  const restore = (async () => {
    if (userData) {
      console.log(userData);
      console.log("restore user from storage");

      try {
        // eslint-disable-next-line
        // @ts-ignore
        const user = new firebase.User(userData, userData.stsTokenManager, userData);

        await firebase.auth().updateCurrentUser(user);

        if (!firebase.auth().currentUser)
          throw 500;
        // eslint-disable-next-line
        // @ts-ignore
        await firebase.auth().currentUser.reload();
        // eslint-disable-next-line
        // @ts-ignore
        userData = firebase.auth().currentUser;
        if (!firebase.auth().currentUser)
          throw 501;

        await Storage.set({ key: 'fbuser', value: JSON.stringify(firebase.auth().currentUser) });
      } catch (err) {
        console.log(err);
        userData = null;
        await Storage.set({ key: 'fbuser', value: '' });
      }
    }

    if (!userData) {
      await firebase.auth().signInAnonymously();
      await Storage.set({ key: 'fbuser', value: JSON.stringify(firebase.auth().currentUser) });
      // eslint-disable-next-line
      // @ts-ignore
      userData = await Storage.get({ key: 'fbuser' })
    }
  });

  await restore();

  if (userData) {
    const app = createApp(App)
      .use(IonicVue, {
        mode: 'ios'
      })
      .use(router)
      .use(PrimeVue)
      .use(moment);

    router.isReady().then( async () => {
      console.log('router ready');
      const { store } = await import('@/store/index.js');
      const utils = await import('@/plugins/utils.js');
      app.use(store);
      app.use(utils.default);

      app.mount('#app');
    });

    defineCustomElements(window);

  } else {
    const { App } = Plugins;
    alert("Lỗi kết nối! Vui lòng kiểm tra kết nối Internet và thử lại.");
    App.exitApp();
  }

});

